var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "el-sp-center"
  }, [_c('div', {
    staticClass: "el-sp-center__header"
  }, [_c('span', [_vm._v("待选人员 (" + _vm._s(_vm.options.length) + ")")]), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPosition,
      expression: "showPosition"
    }],
    staticClass: "el-sp-center__position",
    attrs: {
      "clearable": "",
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changePosition
    },
    model: {
      value: _vm.position,
      callback: function ($$v) {
        _vm.position = $$v;
      },
      expression: "position"
    }
  }, _vm._l(_vm.positionList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1), _vm.options.length === 0 ? _c('span', {
    staticClass: "el-sp-center__empty-text"
  }, [_vm._v("无数据")]) : _vm._e(), _vm.options.length !== 0 ? [_c('ul', {
    staticClass: "el-sp-center__list"
  }, [_c('li', {
    staticClass: "el-sp-center__item"
  }, [_c('div', {
    staticClass: "el-sp-center__item__check"
  }, [_vm.type === 'checkbox' ? _c('el-checkbox', {
    on: {
      "change": _vm.checkAll
    },
    model: {
      value: _vm.isCheckedAll,
      callback: function ($$v) {
        _vm.isCheckedAll = $$v;
      },
      expression: "isCheckedAll"
    }
  }) : _vm._e()], 1), _c('b', {
    staticClass: "el-sp-center__item__name"
  }, [_vm._v(_vm._s(_vm.theadData.name))]), _c('b', {
    staticClass: "el-sp-center__item__id"
  }, [_vm._v(_vm._s(_vm.theadData.id))]), _c('b', {
    staticClass: "el-sp-center__item__dept"
  }, [_vm._v(_vm._s(_vm.theadData.dept))])]), _vm._l(_vm.options, function (option, index) {
    return _c('li', {
      key: index,
      staticClass: "el-sp-center__item"
    }, [_c('div', {
      staticClass: "el-sp-center__item__check"
    }, [_vm.type === 'checkbox' ? _c('el-checkbox', {
      attrs: {
        "disabled": option._disabled
      },
      on: {
        "change": function ($event) {
          return _vm.checkOne(option);
        }
      },
      model: {
        value: option._isSelected,
        callback: function ($$v) {
          _vm.$set(option, "_isSelected", $$v);
        },
        expression: "option._isSelected"
      }
    }) : _vm._e(), _vm.type === 'radio' ? _c('el-radio', {
      attrs: {
        "label": true,
        "disabled": option._disabled
      },
      on: {
        "change": function ($event) {
          return _vm.checkOne(option);
        }
      },
      model: {
        value: option._isSelected,
        callback: function ($$v) {
          _vm.$set(option, "_isSelected", $$v);
        },
        expression: "option._isSelected"
      }
    }, [_vm._v("   ")]) : _vm._e()], 1), _c('span', {
      staticClass: "el-sp-center__item__name",
      attrs: {
        "title": option.name
      },
      on: {
        "click": function ($event) {
          return _vm.checkItem(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.name) + " ")]), _c('span', {
      staticClass: "el-sp-center__item__id",
      attrs: {
        "title": option.id
      },
      on: {
        "click": function ($event) {
          return _vm.checkItem(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.id) + " ")]), _c('span', {
      staticClass: "el-sp-center__item__dept",
      attrs: {
        "title": option.dept
      },
      on: {
        "click": function ($event) {
          return _vm.checkItem(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.dept) + " ")])]);
  }), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowLoadmore,
      expression: "isShowLoadmore"
    }],
    staticClass: "el-sp-center__loadmore",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.searchUser('loadmore');
      }
    }
  }, [_vm._v(" 加载更多... ")])], 2)] : _vm._e()], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };